import { HStack, Heading } from "@chakra-ui/react";

export function TabHeading({ text }: { text: string }) {
  return (
    <HStack alignContent={"center"} gap={4} bgColor={"brand.200"} px={2}>
      <Heading>{text}</Heading>
    </HStack>
  );
}
